import { styled } from '@mui/material/styles';
import { Box, IconButton, DialogTitle } from '@mui/material';

export const Container = styled(Box)(() => ({
  padding: 30,
}));

export const Header = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  alignItems: 'center',
  padding: '10px 20px',
}));

export const HDialogTitle = styled(DialogTitle)(() => ({
  padding: 0,
  fontSize: '22px',
}));
export const HIconButton = styled(IconButton)(() => ({
  background: '#ffe2e2',
}));

export const BoxButtons = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'end',
  alignItems: 'center',
  gap: '15px',
}));
